import axios from "axios";
import { baseUrl, mainBaseUrl } from "../App";
import "./fp.scss";
import loaderimg from "../Images/InsistentTautGodwit-small.gif";
import { useState } from "react";
import { Redirect, useHistory } from "react-router";

const ForgotPass = () => {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [token, setToken] = useState("");
  const [password, setPassword] = useState("");
  const [cpassword, setCpassword] = useState("");
  const [loader, setloader] = useState(false);
  const [success, setSuccess] = useState(false);
  const [otpsuccess, setOtpSuccess] = useState(false);

  const history = useHistory();

  const routeDashboard = () => {
    history.push({
      pathname: "/",
    });
  };

  const sendOtp = () => {
    axios
      .post(
        `${mainBaseUrl}/forgetPassword`,
        { email: email },
        {
          headers: {
            "API-Key": baseUrl,
          },
        }
      )
      .then((res) => {
        setloader(false);
        setSuccess(true);
        alert("Please check your mail for OTP");
      })

      .catch((e) => {
        alert("Mail id is not registerd or is incorrect");
        setloader(false);
      });
  };

  const verifyOtp = () => {
    axios
      .post(
        `${mainBaseUrl}/verifyOtp`,
        { email: email, otp: otp },
        {
          headers: {
            "API-Key": baseUrl,
          },
        }
      )
      .then((res) => {
        setToken(res.data.token);
        setloader(false);
        setOtpSuccess(true);
      })
      .catch((e) => {
        alert("Wrong OTP");
        setloader(false);
      });
  };

  const newPass = () => {
    if (password === cpassword) {
      axios
        .post(
          `${mainBaseUrl}/resetPassword`,
          { email: email, password: password },
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "API-Key": baseUrl,
            },
          }
        )
        .then((res) => {
          setloader(false);
          alert("Password changed successfully");
          routeDashboard();
          // setSuccess(true);
        })

        .catch((e) => {
          alert(e.response.statusCode);
          setloader(false);
        });
    } else {
      alert("Password do not match");
      setloader(false);
    }
  };

  if (loader === true) {
    return (
      <div className="imgContainer">
        <img className="gif" src={loaderimg} alt="" />
      </div>
    );
  }

  return (
    <div className="fp">
      <div className="img-content">
        <div className="text">
          <p>Change Password</p>
          <p className="secondWala">
            Make sure that the password is <b>strong </b>{" "}
          </p>
        </div>
      </div>

      {success === false ? (
        <div className="main-content">
          <div className="inputContainerPass">
            <input
              onChange={(event) => setEmail(event.target.value)}
              type="email"
              placeholder="Enter Email Id"
            />
            <button
              onClick={() => {
                sendOtp();
                setloader(true);
              }}
            >
              Send OTP
            </button>
          </div>
        </div>
      ) : otpsuccess === false ? (
        <div className="main-content">
          <div className="inputContainerPass">
            <input
              onChange={(event) => setOtp(event.target.value)}
              type="text"
              placeholder="Enter OTP"
            />
            <button
              onClick={() => {
                verifyOtp();
                setloader(true);
              }}
            >
              Verify OTP
            </button>
          </div>
        </div>
      ) : (
        <div className="main-content">
          <div className="inputContainerPass">
            <input
              onChange={(event) => setPassword(event.target.value)}
              type="password"
              placeholder="Enter new password"
            />
            <input
              onChange={(event) => setCpassword(event.target.value)}
              type="password"
              placeholder="Confirm password"
            />
            <button
              onClick={() => {
                newPass();
                setloader(true);
              }}
            >
              Confirm Password
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default ForgotPass;
